import PropTypes from "prop-types";

import withStyles from "@mui/styles/withStyles";
import { Tooltip } from "@mui/material";
import { Error as IconWarning } from "@mui/icons-material";

const styles = theme => ({
  icon: {
    color: theme.palette.warning.main,
  },
});

function WarningIcon({ tooltip, classes }) {
  return (
    <Tooltip title={tooltip}>
      <IconWarning fontSize="small" className={classes.icon} />
    </Tooltip>
  );
}

WarningIcon.propTypes = {
  tooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
};

export default withStyles(styles)(WarningIcon);
